const initialState = {
    // Rehydrate from sessionStorage so a full page reload (e.g. the
    // window.location.href navigation into /code/project) doesn't forget
    // where the user came from.
    selectionBackRoute:
        sessionStorage.getItem('selectionBackRoute') || '/kitSelection',
}

const navigation = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_SELECTION_BACK_ROUTE':
            return {
                ...state,
                selectionBackRoute: action.payload,
            }

        default:
            return state
    }
}

export default navigation